import type { TopologyNode } from '@/services/observability-api';

const serviceStyles = {
  client: { label: 'Client', className: 'border-blue-300 bg-blue-100', minimapColor: '#93c5fd' },
  bff: { label: 'BFF', className: 'border-lavender-300 bg-lavender-100', minimapColor: '#d4c9ff' },
  controller: {
    label: 'Controller',
    className: 'border-amber-300 bg-amber-100',
    minimapColor: '#fcd34d',
  },
  data: { label: 'Data', className: 'border-emerald-300 bg-emerald-100', minimapColor: '#6ee7b7' },
  facade: { label: 'Facade', className: 'border-pink-300 bg-pink-100', minimapColor: '#f9a8d4' },
  ext: {
    label: 'External service',
    className: 'border-orange-300 bg-orange-100',
    minimapColor: '#fdba74',
  },
};

export function nodePresentation(node: Pick<TopologyNode, 'id' | 'kind'>) {
  if (node.kind === 'external') {
    return {
      label: 'external',
      className: 'border-slate-400 bg-slate-200',
      minimapColor: '#94a3b8',
    };
  }
  if (node.kind === 'topic') {
    return { label: 'topic', className: 'border-peach-300 bg-peach-50', minimapColor: '#ffc7b3' };
  }
  for (const [suffix, style] of Object.entries(serviceStyles)) {
    if (node.id.endsWith(`-${suffix}`)) return style;
  }
  return {
    label: 'service',
    className: 'border-neutral-300 bg-neutral-100',
    minimapColor: '#d6d3d1',
  };
}
